module.exports = __webpack_public_path__ + "img/agro-full.44a26dc6.png";